export default __webpack_public_path__ + "static/media/Boots of Unrest.3bf83b2b.jpg";